const enum HeaderCharmType {
    FeedbackCharm,
    FeatureFlagsCharm,
    HelpCharm,
    PersonaCharm,
    SettingsCharm,
    WaffleCharm,
    DiagnosticsCharm,
    GetStartedCharm,
    WhatsNewCharm,
    TodoCharm,
    ActivityFeedCharm,
    TimePanelCharm,
}

export default HeaderCharmType;
